export default "__VITE_ASSET__1G4bJpme__"